import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'react-toastify';

import {
  addLeagueToFavorite,
  removeLeagueFromFavorite,
} from '@/utils/actions/leagues/leagueFavorites';

export const useFavoriteLeagueMutation = () => {
  const queryClient = useQueryClient();

  const addToFavorites = useMutation({
    mutationFn: async (data: { moduleUuid: string; moduleFor: number }) => {
      const result = await addLeagueToFavorite(data);
      if (result.error) throw new Error(result.error);
      return result.data;
    },
    onSuccess: (_data) => {
      queryClient.invalidateQueries({ queryKey: ['RECOMMENDED_LEAGUES'] });
    },
    onError: () => {
      toast.error('Failed to add to favorites. Please try again.');
    },
  });

  const removeFromFavorites = useMutation({
    mutationFn: async (data: { moduleUuid: string; moduleFor: number }) => {
      const result = await removeLeagueFromFavorite(data);
      if (result.error) throw new Error(result.error);
      return result.data;
    },
    onSuccess: (_data) => {
      queryClient.invalidateQueries({ queryKey: ['RECOMMENDED_LEAGUES'] });
    },
    onError: () => {
      toast.error('Failed to remove from favorites. Please try again.');
    },
  });

  return {
    addToFavorites,
    removeFromFavorites,
    isAdding: addToFavorites.isPending,
    isRemoving: removeFromFavorites.isPending,
  };
};
